import module from '../module';
import scopeUtil from '../../../utils/scope';
import Constants from "../../../utils/CommonConstants";
import CommonConstants from "../../../utils/CommonConstants";
import { communicationService } from "../../../services/communicationService";
import { commandKeys } from "../../../shared/commandKeys";
import { InviteUserController } from "../../order/controllers/InviteUserController";

class InviteLinkDirectiveController {
    static $inject = ['$scope', 'CartService', 'ConfigurationService', '$rootScope', '$translate', '$mdDialog'];

    constructor(scope, cartService, configurationService, rootScope, $translate, dialogService) {

        this._scope = scope;
        this._rootScope = rootScope;
        this._cartService = cartService;
        this._configurationService = configurationService;
        this.$translate = $translate;
        this._dialogService = dialogService;

        scope.invitationLink = this._cartService.getInviteSingleLink();
        scope.invitationType = this._cartService.getInvitationType();
        scope.invitationCode = this._cartService.getInviteCode();
        scope.minimumOrderMessage = null;
        scope.ownerDiscountMessage = null;

        scope.copyToClipboard = () => this._copyClipboard();
        scope.isShowInviteLink = () => this._isShowInviteLink();
        scope.isMarketingShow = () => this._isMarketingShow();
        scope.inviteUser = () => this._inviteUser();
        rootScope.$on(Constants.Events.ORDER_CREATED, () => this._initInvitationCode());
        rootScope.$on(Constants.RootEvents.CART_CHANGED, () => this._cartChanged())

    }

    async $onInit() {
        await this._initInvitationCode();
        await this._updateMinimumOrderMessage();
    }

    async _inviteUser() {
      let self = this;
      this._dialogOptions = {
        controller: InviteUserController,
        template: require('../../order/views/inviteUser.jade')(),
        escapeToClose: true,
        locals: {},
        onRemoving: function (event, removePromise) {
          self._rootScope.$broadcast(Constants.Events.DIALOG_CLOSED);
        }
      };

      await this._dialogService.show(this._dialogOptions);
    }


    async _cartChanged() {
        await this._initInvitationCode();
        await this._updateMinimumOrderMessage();
    }

    _isShowInviteLink() {
        return this._scope.cart &&
            !(this._scope.cart.cartStatus === 'OWNER_CHECKING_OUT' || this._scope.cart.cartStatus === 'CHECKING_OUT');
    }

    _isMarketingShow() {
        return this.retailer && this._scope.cart &&
        (this.retailer.cartonomyMode !== CommonConstants.CartonomyMode.marketing || this._scope.cart.items.length > 0)
    }

    async _initInvitationCode() {
        const siteLocation = await communicationService.requestToParent(commandKeys.getLocation, {});
        var _retailer = this._configurationService.getRetailer().retailer;
        this.retailer = _retailer;
        this._scope.cart = await this._cartService.getCart();
        this._scope.invitationCode = this._cartService.getInviteCode();
        if (this._scope.cart && this._scope.cart.id) {
            this._scope.invitationCode = await this._cartService.getShareTokenByCartId(this._scope.cart.id);
            this._cartService.setInviteCode(this._scope.invitationCode);
            this._cartService.setInvitationType(Constants.InvitationTypes.share);
        }

        let siteUrl;
        const retailerSiteUrl = _retailer.website.startsWith('https://') ? _retailer.website : 'https://' + _retailer.website;
        if (_retailer.cartonomyMode === CommonConstants.CartonomyMode.marketing && this._scope.cart && this._scope.cart.items[0]) {
            siteUrl = this._scope.cart.items[0].productUrl;
        }  else {
            siteUrl = retailerSiteUrl;
        }

        if (siteLocation && siteLocation.origin) {
            siteUrl = siteUrl.replace(retailerSiteUrl, siteLocation.origin);
        } else if (_retailer.retailerType === 'Shopify') {
            siteUrl = 'https://' + siteUrl;
        }
        this._scope.invitationLink = siteUrl + Constants.INVITE_LINK + this._scope.invitationCode;

        this._cartService.setInviteSingleLink(this._scope.invitationLink);

        scopeUtil.apply(this._scope);

    }

    async _updateMinimumOrderMessage() {
        const retailer = this._configurationService.getRetailer().retailer;
        if (this._scope.cart) {
            if (retailer.minimumOrderAmount > 0) {
                if (this._scope.cart.cartItemTotal >= retailer.minimumOrderAmount) {
                    this._scope.minimumOrderMessage = this.$translate.instant('client.group.free_shipping');
                } else {
                    this._scope.minimumOrderMessage = this.$translate.instant('client.group.amount_for_free_shipping', {amount:  (retailer.minimumOrderAmount - this._scope.cart.cartItemTotal).toFixed(2)});
                }
            }
            if ((this._scope.cart.cartDiscount && this._scope.cart.cartDiscount > 0
                && await this._cartService.isOwner(this._scope.cart))
                || retailer.cartonomyMode === CommonConstants.CartonomyMode.marketing) {
                if (retailer.cartonomyMode === CommonConstants.CartonomyMode.marketing) {
                    this._scope.ownerDiscountMessage = this.$translate.instant('client.group.invite_discount', {cartDiscount: this._scope.cart.cartDiscount.toFixed(2), availableDiscount: this._scope.cart.availableDiscount.toFixed(2)});
                } else {
                    this._scope.ownerDiscountMessage =  this.$translate.instant('client.group.discount', { cartDiscount: this._scope.cart.cartDiscount.toFixed(2)})
                }
            } else {
                this._scope.ownerDiscountMessage = null;
            }
        } else {
            this._scope.minimumOrderMessage = null;
            this._scope.ownerDiscountMessage = null;
        }
        scopeUtil.apply(this._scope);
    }

    async _copyClipboard() {
        this._cartService.copyClipboard(this._scope.invitationLink);
    }
}

module.directive('inviteLink', function () {
    return {
        scope: true,
        templateUrl: 'modules/shared/views/inviteLink.html',
        controller: InviteLinkDirectiveController
    };
});



// WEBPACK FOOTER //
// ./src/modules/shared/directives/InviteLinkDirective.js